var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.431 3.39959H9.531C9.7243 3.39959 9.88101 3.24288 9.88101 3.04958V0.949587C9.88101 0.756322 9.7243 0.599609 9.531 0.599609H7.431C5.30568 0.601939 3.58332 2.32426 3.58102 4.44959V6.8996H1.13102C0.937718 6.8996 0.781006 7.05631 0.781006 7.24961V9.3496C0.781006 9.5429 0.937718 9.69961 1.13102 9.69961H3.58102V17.0496C3.58102 17.2429 3.73773 17.3996 3.93103 17.3996H6.03103C6.22433 17.3996 6.38104 17.2429 6.38104 17.0496V9.69961H8.83105C8.98162 9.69952 9.11527 9.60308 9.16284 9.46021L9.86283 7.36022C9.92393 7.17683 9.82477 6.97864 9.64138 6.91755C9.60581 6.9057 9.56854 6.89963 9.53103 6.8996H6.38104V4.44959C6.38101 3.8697 6.85111 3.39959 7.431 3.39959Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5f5ae371b13384916488116758116a06.svg";
export { ForwardRef as ReactComponent };